module.exports = {
  "Fintech_Payment_2_GErt_OBdg": "Ingresa tu número de celular de 10 dígitos",
  "Fintech_Payment_2_SslK_PSat": "Ingresa un número de celular con la cantidad correcta de dígitos",
  "Fintech_Payment_2_pXvO_pqxr": "Solo se pueden ingresar números",
  "Fintech_Payment_modification_JNDB_IyfS": "Cargar de nuevo",
  "Fintech_Payment_information_igvK_UYAz": "Aquí puedes agregar beneficiarios y determinar los porcentajes que les corresponderán.",
  "Fintech_Payment_deposit_sXgz_qKip": "Verifica los detalles e ingresa el monto que deseas depositar en tu {{DiDi_Cuenta}}.",
  "Fintech_Payment_modification_MBsk_LuPn": "¿Cargar de nuevo ahora?",
  "Fintech_Payment_KYC_gnTH_YXOJ": "Ciudad/Región",
  "Fintech_Payment_KYC_ACoB_YJFy": "El código de verificación no es válido. Inténtalo de nuevo.",
  "Fintech_Payment_KYC_SpcY_yEkL": "Colonia (opcional)",
  "Fintech_Payment_AF_iYUV_RZqQ": "Destinatario",
  "Fintech_Payment_OTP_pEfV_rJQv": "No tengo WhatsApp",
  "Fintech_Payment_information_gLTw_udZk": "Nombre del beneficiario",
  "Fintech_Payment_Bankstatement_VJGG_mzkf": "Detalles de movimientos",
  "Fintech_Payment_Bankstatement_BQiZ_jAEw": "Índice de abreviaturas",
  "Fintech_Payment_website_ojec_kGmp": "Ingresa tus datos",
  "Fintech_Payment_out_EwYp_MJFT": "Ingresa tu CLABE",
  "Fintech_Payment_out_DUKE_nxdr": "Agregar un alias",
  "Fintech_Payment_out_dMcV_dFtS": "Banco destinatario",
  "Fintech_Payment_information_DIYt_yZyx": "Número de celular",
  "Fintech_Payment_modification_plkZ_lsUh": "Uso de CFDI",
  "Fintech_Payment_website_vyuH_wVPZ": "Solo se pueden ingresar letras en español, espacios y guiones (-)",
  "Fintech_Payment_out_RDFl_sSQx": "CLABE copiada",
  "Fintech_Payment_KYC_dKAT_heay": "La CURP y el género no coinciden. Por favor, revisa la información ingresada.",
  "Fintech_Payment_Bankstatement_SGNJ_vMFp": "Dirección: {{Sofipo_address}}",
  "Fintech_Payment_KYC_eGso_jeAS": "Confirmar",
  "Fintech_Payment_website_uwvO_Tgil": "Por favor, ingresa un formato de correo electrónico válido",
  "Fintech_Payment_AF_EsIM_hGCv": "May.",
  "Fintech_Payment_KYC_hVEQ_wtLy": "La dirección no puede exceder de 200 caracteres",
  "Fintech_Payment_Optimization_NOin_alml": "Actualizado",
  "Fintech_Payment_KYC_gWXw_nbwh": "Verificación completa",
  "Fintech_Payment_Bankstatement_UMxV_lSvi": "{{JP_Sofiexpress}} recibe las consultas, reclamaciones o aclaraciones en su unidad especializada de atención a usuarios (UNE) ubicada en {{Sofipo_UNE_address}} y por correo electrónico a {{Sofipo_UNE_email}} o por teléfono al {{Sofipo_UNE_telephone_number}}, así como en cualquiera de sus sucursales u oficinas. En caso de no obtener una respuesta satisfactoria, podrás acudir a la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF) en {{condusef_URL}} o por teléfono al {{condusef_telephone_number1}} o {{condusef_telephone_number2}}.",
  "Fintech_Payment_Optimization_tyId_PGmu": "Gastos",
  "Fintech_Payment_deposit_epmY_qubZ": "Depositar mediante SPEI",
  "Fintech_Payment_AF_VBip_Mdss": "La sesión ha expirado. Por favor, inicia sesión nuevamente.",
  "Fintech_Payment_AF_MXod_mPID": "Saldo",
  "Fintech_Payment_out_qfne_lRTR": "Transferir con CLABE",
  "Fintech_Payment_limits_jyYN_OrOp": "Supervisado por la CNBV",
  "Fintech_Payment_information_JlDn_qwie": "Beneficiario {{successor_id}}",
  "Fintech_Payment_Bankstatement_rIXn_CUsc": "Emisor del pago",
  "Fintech_Payment_page_OQck_lyCE": "Me sigue interesando",
  "Fintech_Payment_limits_daNT_fZSS": "Por favor, inténtalo de nuevo más tarde",
  "Fintech_Payment_Bankstatement_caBV_jSuG": "Nombre: {{client_name}}",
  "Fintech_Payment_website_bEUT_jSda": "En lista de espera. Te escribiremos un sms/correo cuando puedas usar {{brand_name}}.",
  "Fintech_Payment_information_ZlKa_dtuo": "¿Confirmas que deseas eliminar este beneficiario?",
  "Fintech_Payment_information_bUKL_JKrn": "Estado, País",
  "Fintech_Payment_AF_HEgl_AkAn": "Jun.",
  "Fintech_Payment_Bankstatement_cklR_SqlI": "Estás viendo tu estado de cuenta. Estos se generan automáticamente de forma mensual e incluyen los movimientos de hasta 12 meses. Si necesitas consultar un estado de cuenta de hace más de 12 meses, comunícate con servicio al cliente. El estado de cuenta más reciente disponible es del {{last_time}}.",
  "Fintech_Payment_Bankstatement_fSIt_lCnP": "Selecciona un periodo",
  "Fintech_Payment_display__aCTQ": "Cargando...",
  "Fintech_Payment_limits_jOLq_KpIA": "El monto que ingresaste supera el límite máximo. Por favor, ajústalo.",
  "Fintech_Payment_AF_gnPZ_eMwX": "Último inicio de sesión: {{last_login_time}}",
  "Fintech_Payment_limits_laEJ_ZcnK": "Error de carga",
  "Fintech_Payment_website_FUOx_KRLc": "Este es un producto de {{Company_name}}",
  "Fintech_Payment_limits_PTcx_pRPt": "El monto que ingresaste debe ser un número entero.",
  "Fintech_Payment_AF_FSRh_XVKV": "No esperes más y recarga tu {{brand_name}} para empezar a usarla",
  "Fintech_Payment_out_jXPS_kJIE": "Destinatario copiado",
  "Fintech_Payment_information_zyZu_choS": "{{beneficiary_percent}} pendiente de asignar",
  "Fintech_Payment_Bankstatement_Vsvj_rvxs": "Depósito",
  "Fintech_Payment_KYC_TVHz_LQmK": "Femenino",
  "Fintech_Payment_deposit_CRGm_UzpX": "Copia y comparte esta información para recibir un depósito en tu {{DiDi_Cuenta}}",
  "Fintech_Payment_Bankstatement_kAPb_djfK": "Fecha",
  "Fintech_Payment_website_JrDT_oghx": "2 minutos",
  "Fintech_Payment_information_LxSZ_QfdR": "Número interior (opcional)",
  "Fintech_Payment_Bankstatement_UDGs_sWUv": "Descripción",
  "Fintech_Payment_modification_XLGP_PkVO": "No se pudo previsualizar el archivo",
  "Fintech_Payment_Bankstatement_vcou_ppHK": "Descargar",
  "Fintech_Payment_out_JVhf_uIrz": "Por lo general, los fondos se reflejarán en el saldo de tu cuenta dentro de {30 segundos}. Si no recibes los fondos dentro de {una hora}, por favor contáctanos.",
  "Fintech_Payment_modification_WpyW_UDnG": "Una vez que elijas cargar de nuevo, la última información fiscal puede cambiar.",
  "Fintech_Payment_deposit_hPpV_qxBY": "Confirma la información",
  "Fintech_Payment_out_xxZL_QggI": "En este momento, puedes transferir hasta {{amount}}.",
  "Fintech_Payment_Optimization_EtqY_nFMb": "No se aplican impuestos debido a que los rendimientos actuales no alcanzan el mínimo establecido",
  "Fintech_Payment_KYC_UCNu_RKcO": "Código postal",
  "Fintech_Payment_KYC_Lwxq_yulz": "El formato del correo electrónico no es válido",
  "Fintech_Payment_page_ZyPv_vdFF": "Invitar por código QR",
  "Fintech_Payment_deposit_wGvf_isDi": "Ingresa tu CLABE",
  "Fintech_Payment_information_SgIA_tmLD": "Beneficiario actualizado correctamente",
  "Fintech_Payment_compliance_cKLo_wJIN": "El monto excede {{amount_limit}}, por favor guarda el destinatario.",
  "Fintech_Payment_modification_zGjh_jAAr": "Verificando tu documento",
  "Fintech_Payment_KYC_Oilm_lUbJ": "Error de red. Inténtalo más tarde.",
  "Fintech_Payment_Bankstatement_bjpO_mnaj": "Dado que {{JP_Sofiexpress}} no cobra a los usuarios comisiones de servicio ni otros cargos, el saldo mínimo que puedes tener es 0.",
  "GDriver_MX_No_more_bWUF": "No hay más datos disponibles.",
  "Fintech_Payment_page_XQQd_oNyh": "Sin invitaciones aún",
  "Fintech_Payment_modification_AByR_jggK": "Ahora no",
  "Fintech_Payment_homepage_aMFD_pFAF": "Habilitaste tu Saldo de {{brand_name}}, por lo que los servicios de recarga de Saldo de {{DiDi}} ya no están disponibles. Esperamos que disfrutes de una experiencia de pago mejorada con tu Saldo de {{brand_name}}. Gracias por tu comprensión y apoyo.",
  "Fintech_Payment_Bankstatement_PYtp_iPQw": "Saldo inicial",
  "Fintech_Payment_out_XYAo_yuwB": "CLABE",
  "Fintech_Payment_AF_kABS_zWvf": "Sep.",
  "Fintech_Payment_Bankstatement_AzQw_luej": "Correo electrónico: {{Sofipo_email}}",
  "Fintech_Payment_page_ocIy_NGRn": "Ingresa un número de celular válido",
  "Fintech_Payment_KYC_OnLo_ZYch": "Ingresa tus datos",
  "Fintech_Payment_homepage_SFsi_SJXU": "Por favor, usa el Saldo de tu {{brand_name}}",
  "Fintech_Payment_KYC_zTko_YFzn": "Esta CURP ya está en uso",
  "Fintech_Payment_out_amMV_dDSd": "CLABE",
  "Fintech_Payment_AF_fOga_XwyT": "No se pudo verificar. Por favor, inténtalo de nuevo",
  "Fintech_Payment_AF_nmDo_eTLN": "Ene.",
  "Fintech_Payment_Bankstatement_hnLc_DSHR": "Retiro",
  "Fintech_Payment_simulado_QWNv_ULIU": "Monto del depósito ({{monetary_unit}})",
  "Fintech_Payment_KYC_Xwxu_tMgl": "Por favor, ingresa esta información.",
  "Fintech_Payment_information_msbx_XiQZ": "¿Qué es el número de cuenta?",
  "Fintech_Payment_deposit_Mlzl_OiyY": "Destinatario",
  "Fintech_Payment_Cap_oZyP_BVoJ": "Reglas de cálculo",
  "Fintech_Payment_interest_VgrE_mFyX": "Total",
  "Fintech_Payment_M2_Network_error_pnLW": "Error de red. Por favor, inténtalo de nuevo.",
  "Fintech_Payment_deposit_VPvi_NjxF": "Banco destino",
  "Fintech_Payment_AF_qJnT_LvYT": "Ver todo",
  "Fintech_Payment_Bankstatement_cqQj_yfpk": "Comisión por transferencia SPEI",
  "Fintech_Payment_AF_qSLd_ePln": "Tipo de movimiento",
  "Fintech_Payment_KYC_OZAY_SMnC": "El formato del nombre no es válido. Por favor, inténtalo de nuevo.",
  "Fintech_Payment_limits_ytGb_sMaw": "El monto ingresado está fuera del rango permitido. Revísalo.",
  "Fintech_Payment_KYC_vZch_DBhR": "Ingresa el código de verificación del SMS",
  "Fintech_Payment_AF_odav_vTWX": "Dic.",
  "Fintech_Payment_information_zqzM_ASyc": "Mantener",
  "Fintech_Payment_Ahorro_FTbq_RnIh": "Por favor, inténtalo de nuevo más tarde",
  "Fintech_Payment_out_eDqd_heBu": "Nombre",
  "Fintech_Payment_Bankstatement_BWgn_zVrT": "Retiros",
  "Fintech_Payment_KYC_Nrcd_vCpz": "El código de verificación expiró",
  "Fintech_Payment_Optimization_DsID_ESxl": "Actualizando",
  "Fintech_Payment_AF_Trse_OFqS": "¡Hola, {{user_name}}!",
  "Fintech_Payment_website_hsGy_KTiW": "Enviar",
  "Global_Rider_1219_Global_Rider_Adding_Card_Components_Optimization_Try_again_gvWg": "Intentarlo de nuevo",
  "Fintech_Payment_page_lcMk_kyGN": "Compartir en WhatsApp",
  "Fintech_Payment_KYC_UfeV_RamV": "La CURP y la fecha de nacimiento no coinciden. Por favor, revisa la información ingresada.",
  "Fintech_Payment_KYC_hava_mqZj": "Masculino",
  "Fintech_Payment_Bankstatement_ewnH_wIGD": "Consultas y quejas",
  "Fintech_Payment_information_tLUn_cjbv": "Ahora no",
  "Fintech_Payment_information_pHvH_OrLr": "Es importante que designes beneficiarios, ya que, en caso de que fallezcas, los recursos de tu cuenta les serán entregados a tus beneficiarios según los porcentajes que hayas determinado.",
  "Fintech_Payment_information_opfz_BtoE": "Código postal",
  "Fintech_Payment_information_EixC_MnqL": "Número de cuenta",
  "Fintech_Payment_modification_ewfK_RdNL": "Mis datos fiscales",
  "Fintech_Payment_AF_BCXN_zpQI": "Todos",
  "Fintech_Payment_out_nRbM_mVvJ": "Error de sistema. Inténtalo otra vez ({{cs_code}})",
  "Fintech_Payment_KYC_XwnO_pauL": "Código postal no válido. Por favor, revísalo.",
  "Fintech_Payment_Bankstatement_dqvf_vpkB": "Tipo de movimiento",
  "Fleet_Resdesign_Data_loading_pcxE": "Cargando datos...",
  "Fintech_Payment_KYC_xqow_swLI": "Omitir",
  "Fintech_Payment_Bankstatement_Seea_rKSe": "Número de teléfono: {{Sofipo_telephone_number}}",
  "Fintech_Payment_website_YdzR_rNSY": "4 pasos",
  "Fintech_Payment_modification_JYgu_ThhR": "Versión de sistema muy antigua. No se permite el acceso al archivo",
  "Fintech_Payment_KYC_KfPp_SnbQ": "Si tienes alguna pregunta, comunícate con el servicio al cliente de JP Sofiexpress al {{sofipo_csphone}}.",
  "Fintech_Payment_Bankstatement_RisF_kGmY": "Aviso importante",
  "Fintech_Payment_KYC_wsSR_nQPv": "Continuar",
  "Fintech_Payment_out_prmp_xxVR": "Titular de la cuenta",
  "Fintech_Payment_KYC_MKmB_EkXV": "Nombre(s)",
  "Fintech_Payment_page_JPfV_zUWX": "¡Ups! Algo salió mal",
  "Fintech_Payment_page_IYZc_JGJx": "Vuelve a intentarlo más tarde o revisa tu conexión. Si el problema persiste, te sugerimos usar otra red.",
  "Fintech_Payment_page_IICG_TMSY": "Compartir para invitar",
  "Fintech_Payment_information_Wjkj_hnPe": "Calle",
  "Fintech_Payment_AF_uUvN_EGHm": "Transferir",
  "Fintech_Payment_page_CTsY_Dmrb": "Entendido",
  "Fintech_Payment_Bankstatement_wIxX_zPcR": "Depósito SPEI",
  "Fintech_Payment_limits_NaMf_JcsO": "Actualizar",
  "Fintech_Payment_Ahorro_dGgq_KZal": "Volver a intentar",
  "Fintech_Payment_KYC_ENgG_RwQm": "Ingresa tu segundo apellido",
  "Fintech_Payment_KYC_cBre_kkHZ": "Te queda un intento para la(s) siguiente(s) {{occupied_retry_limit_hour}} hora(s). Si no es válido, podrás volver a intentarlo después de {{occupied_retry_limit_hour}} hora(s).",
  "Fintech_Payment_page_sVWx_pnmL": "Actualiza tu aplicación para participar, o haz clic para ver más promociones de {{didi_cuenta}}.",
  "Fintech_Payment_out_MSnG_HwNe": "Reciente",
  "Fintech_Payment_out_GPAk_BVgb": "Destinatario",
  "Fintech_Payment_out_xqdz_fptx": "Banco destinatario",
  "Fintech_Payment_helpcenter_kDlf_knuA": "Ayuda de {{brand_name}}",
  "Fintech_Payment_Bankstatement_NBuR_UWJy": "Destinatario",
  "Fintech_Payment_Bankstatement_gHRD_NonM": "Saldo promedio diario",
  "Fintech_Payment_AF_iGoO_ypBi": "Movimientos",
  "Fintech_Payment_modification_MdCM_dIqR": "Formato de archivo no válido",
  "Fintech_Payment_out_KRxS_XwKV": "Continuar",
  "Fintech_Payment_AF_HwIo_FrYZ": "Detalles del movimiento",
  "Fintech_Payment_compliance_Wyil_Zaqm": "Guardar destinatario",
  "Fintech_Payment_compliance_kmji_yDPA": "Guarda el destinatario para que la próxima vez sea más fácil transferirle",
  "Fintech_Payment_ABtest_DgLn_aapk": "Generando CLABE. Una vez lista, te notificaremos por correo y SMS",
  "Fintech_Payment_modification_krBM_IhkQ": "Régimen fiscal",
  "Fintech_Payment_information_SqPO_GduE": "Mi perfil",
  "Fintech_Payment_Optimization_tHGy_IYgN": "Suelta para actualizar",
  "Fintech_Payment_information_gien_BDnw": "El beneficiario debe tener entre 18 y 85 años",
  "Fintech_Payment_information_gzjP_DzDg": "Segundo apellido del beneficiario",
  "Fintech_Payment_ABtest_nNTe_vZMb": "No se pudo copiar. Por favor, inténtalo de nuevo",
  "Fintech_Payment_limits_fmtm_NrdR": "Aceptar",
  "Fintech_Payment_page_oDTv_Emyj": "Ahora no, gracias",
  "Fintech_Payment_Bankstatement_UpAF_OORe": "Si tienes alguna duda sobre los movimientos u otra información, comunícate con el servicio de atención al cliente al {{CS_phone_number}}. Recuerda que tienes hasta 90 días para solicitar cualquier aclaración.",
  "Fintech_Payment_interest_BAfU_KYJw": "Rendimientos",
  "Fintech_Payment_information_cBgX_dXkO": "Número exterior",
  "Fintech_Payment_out_sDmk_VATG": "(Opcional)",
  "Fintech_Payment_information_rYgt_cISP": "El porcentaje no puede ser inferior al 1%",
  "Fintech_Payment_interest_kGNQ_pVHx": "Impuesto deducido",
  "Fintech_Payment_AF_QpIB_AERj": "Feb.",
  "Fintech_Payment_information_FDpV_ODgJ": "Primer apellido del beneficiario",
  "Fintech_Payment_website_mavi_GbHP": "Correo electrónico:",
  "Fintech_Payment_out_YhXy_rMmr": "Haz depósitos a tu {{brand_name}} con la siguiente información",
  "Fintech_Payment_Bankstatement_jnum_icwT": "Identificación del movimiento",
  "Fintech_Payment_Optimization_bymF_byCA": "Resultado",
  "Fintech_Payment_Homepage_lqUj_UKQg": "Deposita",
  "Fintech_Payment_deposit_qpup_NGOx": "CLABE",
  "Fintech_Payment_limits_EZti_bVFY": "El monto que ingresaste no puede ser 0.",
  "Fintech_Payment_KYC_DtGd_zTDS": "Correo electrónico",
  "Fintech_Payment_website_LWta_xkpm": "Enviado correctamente",
  "Fintech_Payment_information_AfvT_aEBB": "Colonia",
  "Fintech_Payment_Bankstatement_hOdy_FqBn": "Saldo",
  "Fintech_Payment_page_xOpT_iwcr": "¿De verdad vas a perder la oportunidad de invitar a tus amigos a unirse a {{DiDi_Cuenta}}? ¡Puedes ayudarles a obtener más rendimientos!",
  "Fintech_Payment_Bankstatement_kxBr_CoBu": "Error del sistema",
  "Fintech_Payment_website_PQAp_tKWp": "¡Te esperamos!",
  "Fintech_Payment_interest_kSNl_nSdf": "Simulador de rendimientos",
  "Fintech_Payment_AF_rfVr_WNwz": "Ago.",
  "Fintech_Payment_ABtest_TuaL_SrVk": "Copiado correctamente",
  "Fintech_Payment_modification_eWBN_NQGs": "Una vez completada la verificación, te notificaremos el resultado por correo electrónico.",
  "Fintech_Payment_KYC_fIJh_dXsj": "Género",
  "Fintech_Payment_interest_bjTF_glLz": "Monto después de deducir impuestos",
  "Fintech_Payment_deposit_knBn_gUEK": "Tu dinero está protegido por el fondo de protección",
  "Fintech_Payment_AF_fXUE_ZcYk": "Consulta de movimientos",
  "Fintech_Payment_KYC_TYRL_UHBj": "El número de teléfono celular no es válido",
  "Fintech_Payment_deposit_MUBS_fNDh": "Banco destino",
  "Fintech_Payment_modification_Gyta_xHeT": "Archivo demasiado grande (supera el límite)",
  "Fintech_Payment_information_gvGr_wpac": "No hay ningún porcentaje disponible para asignar a un nuevo beneficiario. Para agregar otro beneficiario, por favor, ajusta primero los porcentajes determinados.",
  "Fintech_Payment_modification_itwI_hUTZ": "No se pudo leer el archivo",
  "Fintech_Payment_modification_RSHt_ndfh": "Segundo apellido",
  "Fintech_Payment_KYC_Qlzk_XvJj": "¡Lo sentimos! Has llegado al límite de {{limit_times}} intentos durante {{occupied_retry_limit_hour}} horas.",
  "Fintech_Payment_information_awgy_TfAc": "Municipio",
  "Fintech_Payment_deposit_CZPp_ckng": "CLABE",
  "Fintech_Payment_Optimization_BIAB_lwdr": "Detalles",
  "Fintech_Payment_limits_nTTb_OIBh": "Monto no válido. Por favor, intenta de nuevo.",
  "Fintech_Payment_KYC_AnWj_fktR": "Ingresa tu información de contacto",
  "Fintech_Payment_Bankstatement_cwrx_hynB": "Vista previa",
  "Fintech_Payment_deposit_tUEw_gdkO": "Normalmente, recibirás el depósito en unos minutos o hasta una hora. Sin embargo, en algunos casos, puede tardar hasta 24 horas. Recibirás una notificación por correo electrónico en cuanto los fondos sean recibidos en tu cuenta.",
  "Fintech_Payment_page_otEb_WJBX": "¿Quieres renunciar a la oportunidad de ayudar a tus amigos a obtener más rendimientos?",
  "Fintech_Payment_out_gwMW_faQG": "Copiar",
  "Fintech_Payment_KYC_eWvY_kNRU": "El nombre no puede exceder de 100 caracteres",
  "Fintech_Payment_Ahorro_mFQz_mpkb": "Mala conexión de red",
  "Fintech_Payment_out_vXtA_BWXM": "Guarda tu CLABE de {{brand_name}} e ingresa la cantidad del depósito.",
  "Fintech_Payment_AF_yLfN_dGSL": "Recargar",
  "Fintech_Payment_KYC_bfgH_PnwM": "Entendido",
  "Fintech_Payment_Bankstatement_Aasp_ARbC": "Apellido paterno: {{client_father_surname}}",
  "Fintech_Payment_deposit_pGCE_WTug": "Tu dinero está protegido por el fondo de protección",
  "Fintech_Payment_Bankstatement_FAXa_uhmr": "Comisión de servicio de transferencias",
  "Fintech_Payment_Bankstatement_HnlA_MYGF": "Dirección: {{client_address}}",
  "Fintech_Payment_AF_gZgm_wjTw": "Confirmar",
  "Fintech_Payment_out_YguV_vhYc": "Completado",
  "Fintech_Payment_out_JvbB_ULMX": "Banco",
  "Fintech_Payment_compliance_myyv_UNBP": "Guardado correctamente",
  "Fintech_Payment_Bankstatement_ylvG_Dywq": "Tasa de comisión por depósito, retiro y transferencia",
  "Fintech_Payment_AF_KMcq_mVba": "Jul.",
  "Fintech_Payment_simulado_DiNq_bAix": "Duración (días)",
  "Fintech_Payment_page_vslk_brnN": "Ver mis invitaciones",
  "Fintech_Payment_page_WqZl_sRoM": "Ver más",
  "Fintech_Payment_information_TrDL_iykt": "Permanecer aquí",
  "Fintech_Payment_information_RBeT_ASwx": "Nombre",
  "Fintech_Payment_optimization_lSek_omte": "Todo",
  "Fintech_Payment_KYC_qrff_Jjlj": "Calle y número (interior y exterior)",
  "Fintech_Payment_out_tpAm_Gebw": "El monto máximo de transferencia es de {{amount}}. Recuerda no excederlo.",
  "Fintech_Payment_KYC_YHhc_UqVg": "Confirma que la CURP que ingresaste sea correcta. Si tienes alguna pregunta, puedes contactar al servicio al cliente de JP Sofiexpress al {{sofipo_csphone}}.",
  "Fintech_Payment_website_oDvN_dDjs": "Te informaremos por SMS y correo electrónico cuando puedas abrir tu {{brand_name}}",
  "Fintech_Payment_modification_AxYk_gqDO": "Primer apellido",
  "Fintech_Payment_KYC_AXpD_yHSr": "Confirma que el número de teléfono celular ingresado sea correcto. Si tienes alguna pregunta, ponte en contacto con el servicio al cliente de JP Sofiexpress al {{sofipo_csphone}}.",
  "Fintech_Payment_Bankstatement_oURi_nwyv": "Pago",
  "Fintech_Payment_information_HyID_LHyK": "Agregar un beneficiario",
  "Fintech_Payment_compliance_XDas_earR": "Error de red. Por favor, inténtalo de nuevo.",
  "Fintech_Payment_page_DKvP_LGHp": "Reintentar",
  "Fintech_Payment_Bankstatement_UsnV_GrXD": "Número de cliente: {{client_ID}}",
  "Fintech_Payment_AF_TplY_FLqG": "Saldo de {{brand_name}}",
  "Fintech_Payment_out_VHkP_Imvq": "Transferir",
  "GRider_part2_Cancel_pNIR": "Cancelar",
  "Fintech_Payment_KYC_VsBG_JucB": "Segundo apellido",
  "Fintech_Payment_Ahorro_DtZv_ntHp": "Conexión de red inestable. Por favor, inténtalo de nuevo más tarde.",
  "Fintech_Payment_information_EmHe_dUby": "Puedes agregar hasta {{beneficiary_max}} beneficiarios.",
  "Fintech_Payment_website_jKqP_Gqla": "Al continuar, aceptas el {{Notice_name}}",
  "Fintech_Payment_KYC_qTby_Fnnc": "El formato de la CURP no es válido. Por favor, inténtalo de nuevo.",
  "Fintech_Credit_adjustment_TzfM_zgIR": "Cerrar sesión",
  "Fintech_Payment_page_xxda_gEqM": "Descarga {{Dinero}}",
  "Fintech_Payment_AF_iknn_PlqT": "Iniciar sesión",
  "Fintech_Payment_KYC_qXAw_pVOQ": "¿Tienes apellido materno? El campo está vacío.",
  "Fintech_Payment_KYC_ysqu_aYrF": "Por favor, acepta y firma el Acuerdo",
  "Fintech_Payment_page_eqrN_OTpK": "Ingresa tu número",
  "Fintech_Payment_information_hgYQ_tQxl": "Dirección de correo electrónico",
  "Fintech_Payment_information_TBSl_StvR": "Copiar",
  "Fintech_Payment_Bankstatement_vlax_qixg": "Continúa en la siguiente página",
  "Fintech_Payment_AF_OEFN_ytYe": "Mar.",
  "Fintech_Payment_Optimization_oOuc_Cfsk": "Ingresos",
  "Fintech_Payment_Page_jeVI_qDzp": "Cargando...",
  "Fintech_Payment_modification_eQwF_xWxX": "Error de red. Inténtalo de nuevo más tarde.",
  "Fintech_Payment_interest_urQk_fzCP": "Monto del depósito",
  "Fintech_Payment_deposit_YUps_erzK": "Depósito enviado",
  "Fintech_Payment_information_DVNj_AgnB": "Guardar",
  "Fintech_Payment_out_yZsY_EvIm": "18 dígitos",
  "Fintech_Payment_information_tTZZ_hLLV": "Establecer el porcentaje aquí",
  "Fintech_Payment_modification_EGDg_LnPx": "RFC",
  "Fintech_Payment_Bankstatement_ODrW_rHOu": "Saldo al cierre",
  "Fintech_Payment_Bankstatement_ePTe_dXpF": "Número de cuenta: {{account_ID}}",
  "Fintech_Payment_KYC_lbWE_gASK": "Primer apellido",
  "Fintech_Payment_Bankstatement_aPih_wMNV": "Depósitos",
  "Fintech_Payment_2_mJns_qxor": "Descargar app",
  "Fintech_Payment_KYC_RgjA_vYVl": "Fecha de nacimiento",
  "Fintech_Payment_Bankstatement_jFfT_dnLZ": "Periodo: {{bank_statement_period}}",
  "Fintech_Payment_AF_pJXV_lZvb": "Abr.",
  "Fintech_Credit_2_uFFp_xzbd": "Código postal",
  "Fintech_Payment_website_lqdT_FJGg": "Nombre:",
  "Fintech_Payment_information_KUsQ_cYXy": "Copiado",
  "Fintech_Payment_AF_WOJT_DqtE": "Depositar",
  "Fintech_Payment_out_UstT_nhmd": "Copia la {CLABE} de tu {{brand_name}} en tu aplicación bancaria o preséntala en tu institución financiera.",
  "Fintech_Payment_interest_xSFa_WJEH": "Duración (mes)",
  "Fintech_Payment_KYC_hCgl_mGgu": "El código de verificación se envió al {{user_phone}}",
  "Fintech_Payment_Bankstatement_JpFH_XKLj": "Estado de cuenta",
  "Fintech_Payment_information_pApu_zbLJ": "Salir",
  "Fintech_Payment_deposit_NBVB_Eeln": "Destinatario",
  "Fintech_Payment_out_eONV_CHHd": "Mis destinatarios",
  "Fintech_Payment_information_ziNL_LQwo": "Si sales de esta sección, la información que hayas ingresado no se guardará. ¿Deseas salir de todos modos?",
  "Fintech_Payment_compliance_VAAJ_cYfZ": "No se pudo guardar. Por favor, inténtalo de nuevo.",
  "Fintech_Payment_information_sROF_duGS": "El número de cuenta es el identificador único de tu cuenta. Servicio al cliente te lo solicitará cuando te comuniques con ellos en caso de que necesites revisar la información de tu cuenta o solicitar tus estados de cuenta.",
  "Fintech_Payment_change_lUYQ_yEus": "Abre tu cuenta en solo 3 minutos",
  "Fintech_Payment_out_KmNP_EINS": "Ingresa una CLABE válida de 18 dígitos",
  "Fintech_Payment_Optimization_dMIL_yaHK": "Desliza para actualizar",
  "Fintech_Payment_Bankstatement_EluZ_PzvO": "Información sobre comisiones",
  "Fintech_Payment_homepage_oPWn_PLKR": "Entendido",
  "Fintech_Payment_KYC_Wocg_BFmh": "Número de celular (para el código de verificación)",
  "Fintech_Payment_Bankstatement_WFuw_mHmR": "Ocurrió un error en la verificación del estado de cuenta",
  "Fintech_Payment_website_lwrz_wDUy": "Número de celular:",
  "Fintech_Payment_KYC_xGBA_EheK": "Reenviar",
  "Fintech_Payment_KYC_MsXR_sJQR": "Lugar de nacimiento",
  "Fintech_Payment_Bankstatement_GvAh_icxd": "Días del periodo: {{days_of_period}}",
  "Fintech_Payment_Optimization_OxQL_YjpS": "Monto total",
  "Fintech_Payment_information_JKkT_xZkL": "El total de los porcentajes es igual a 100%",
  "Fintech_Payment_page_rBAg_wXlw": "Sesión no iniciada",
  "Fintech_Payment_information_QXCX_lMaj": "Fecha de nacimiento",
  "Fintech_Payment_Bankstatement_eert_SSpI": "Monto",
  "Fintech_Payment_AF_BUgR_eCUa": "Nov.",
  "Fintech_Payment_information_VbVV_XOSn": "Eliminar",
  "Fintech_Payment_information_ViRA_fPZX": "Determina los porcentajes para los beneficiarios. El total de los porcentajes debe ser 100%.",
  "Fintech_Payment_website_eJnt_dWIz": "Abrir tu {{brand_name}} toma unos 2 min. y deberás verificar tu identidad",
  "Fintech_Payment_information_bqmo_InXV": "Datos del beneficiario",
  "Fintech_Payment_deposit_fTwc_mSVi": "Abre la aplicación o sitio web de tu entidad financiera y busca la opción de transferencia. Luego copia y pega la CLABE.",
  "Fintech_Payment_Bankstatement_ZjXW_HvDF": "Tipo",
  "Fintech_Payment_AF_kbUg_IwcT": "¡Hola, nos alegra verte!",
  "Fintech_Payment_Optimization_onZm_HWQv": "Entendido",
  "Fintech_Payment_information_QZfY_vkgM": "Información personal",
  "Fintech_Payment_modification_DmzX_NThI": "Estos son tus datos fiscales más recientes. Por favor, asegúrate de coincidan con los del SAT; si no es así, vuelve a cargarlos.",
  "Fintech_Payment_2_WgYE_UdrG": "Error de verificación por motivos de seguridad",
  "Fintech_Payment_2_nhbq_BHft": "Puedes guardar la imagen e invitar a tus amigos a que escaneen el código QR de arriba para unirse a la promoción.",
  "Fintech_Payment_page_VCEr_tmwW": "Elige una forma de compartir",
  "Fintech_Payment_out_EOvE_qAwT": "Compartir información",
  "Fintech_Payment_information_kxof_vUbv": "Estado",
  "Fintech_Payment_page_YKwh_MTEd": "Nueva versión disponible",
  "Fintech_Payment_information_kcbW_iRYZ": "País",
  "Wallet_App_V2_Please_confirm_Pdiy": "Revisa tu configuración de red e inténtalo de nuevo más tarde.",
  "Fintech_Payment_out_pxGY_wlQW": "Ingresa el monto de la transferencia",
  "Fintech_Payment_Bankstatement_nQyR_PjUQ": "Moneda",
  "Fintech_Payment_out_mTCa_SdSS": "Monto de la transferencia",
  "Fintech_Payment_information_xbPB_LJNs": "Una vez guardada, la información anterior será legalmente aplicable y ejecutable. ¿Guardar ahora?",
  "Fintech_Payment_KYC_xTXj_JDgc": "Este número de teléfono celular ya está en uso",
  "Fintech_Payment_AF_HEfh_nZDt": "Sin movimientos",
  "Fintech_Payment_modification_dczQ_FbPu": "Tus datos fiscales se actualizaron correctamente",
  "Fintech_Payment_Bankstatement_PCJo_LTwh": "Comisión de servicio por retiros",
  "Fintech_Payment_Bankstatement_qAyc_YplQ": "No se pueden cargar los datos. Por favor, inténtalo más tarde.",
  "Fintech_Payment_KYC_Aufz_tEJN": "Entendido",
  "Fintech_Payment_page_CsDR_GUBk": "Volver a intentar",
  "Fintech_Payment_Optimization_SToL_eqvn": "Filtrar",
  "Fintech_Payment_modification_GLNo_TyMd": "Nombre(s)",
  "Fintech_Payment_Bankstatement_QESf_XgpX": "Apellido materno: {{client_mother_surname}}",
  "Fintech_Payment_Homepage_GLan_EOfn": "Tu dinero protegido por el fondo de protección",
  "Fintech_Payment_out_VYYS_orQb": "Titular de la cuenta",
  "Fintech_Payment_page_gsRP_Xfxf": "Recordar",
  "Fintech_Payment_information_hHXE_gOtp": "El total de los porcentajes supera el {{exceed_percent}}. Por favor, ajusta las asignaciones.",
  "Fintech_Payment_Bankstatement_qwYv_fnps": "Transferencia",
  "Fintech_Payment_KYC_BHGw_Oqap": "CURP",
  "Fintech_Payment_out_lghW_FUcU": "Cómo recargar tu saldo",
  "Fintech_Payment_AF_tkBP_jobH": "Oct.",
  "Fintech_Payment_Bankstatement_FiNb_nubW": "Página {{page_number}} de {{number_of_pages}}",
  "Fintech_Payment_out_QYBO_jRKW": "Concepto",
  "Fintech_Payment_interest_BbNK_VACp": "Duración (meses)",
  "Fintech_Payment_Bankstatement_tWjm_XCjp": "Total",
  "Fintech_Payment_Bankstatement_lSib_SWyR": "No se encontró el movimiento en el estado de cuenta",
  "Fintech_Payment_website_zuqt_NNQR": "Por favor, ingresa un número de 10 dígitos",
  "Fintech_Payment_helpcenter_jjmJ_itJL": "Respuesta"
}